/** 1 ГБ = 1024³ байт — так же считают панель и триал, иначе цифры разойдутся с бекендом. */
export const GIB = 1024 * 1024 * 1024;
const MIB = 1024 * 1024;

/**
 * Объём трафика для UI: до 1 ГБ — «595 МБ», дальше — «2,1 ГБ»
 * (одна десятичная, запятая как разделитель).
 */
export function formatBytes(bytes: number): string {
  const safe = Number.isFinite(bytes) && bytes > 0 ? bytes : 0;
  if (safe < GIB) {
    return `${Math.round(safe / MIB)} МБ`;
  }
  return `${(safe / GIB).toFixed(1).replace('.', ',')} ГБ`;
}

/**
 * Квота в гигабайтах без лишних нулей: «7 ГБ», «7,5 ГБ».
 * Для тарифных строк вида «7 ГБ/мес», где «7,0» выглядит как опечатка.
 */
export function formatGb(bytes: number): string {
  const safe = Number.isFinite(bytes) && bytes > 0 ? bytes : 0;
  const rounded = Math.round((safe / GIB) * 10) / 10;
  const text = Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1).replace('.', ',');
  return `${text} ГБ`;
}
